import { getJWT, getLocal } from '../Utils/Profile'
import { BASEAPI } from './constants'

const getReport = async (
    fromDate: string,
    toDate: string,
    downloadType: 'pdf' | 'excel'
) => {
    const commerce = localStorage.getItem('currentUser')
    const commerceData: ICommerceBO = commerce ? JSON.parse(commerce) : null
    const internalID = commerceData.sEstablecimiento + getLocal()
    const res = await fetch(
        `${BASEAPI}amipos-back/report/sale/${internalID}/${fromDate}/${toDate}/${downloadType}`,
        {
            method: 'GET',
            headers: {
                Authorization: getJWT(),
            },
        }
    )
        .then((response) => {
            return response.json()
        })
        .catch((error) => {
            console.error(error)
            return null
        })
    return res
}

export { getReport }
